"use client";

import { useTheme } from "next-themes";
import { useEffect } from "react";

declare global {
    interface Window {
        setTheme: (newTheme: "light" | "dark" | "system") => void;
    }
}

export function ThemeConsoleHelper() {
    const { setTheme, theme, resolvedTheme } = useTheme();

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.setTheme = (newTheme: "light" | "dark" | "system") => {
                setTheme(newTheme);
                console.log(`%c Theme changed to: ${newTheme} `, 'background: #ed145b; color: #fff; font-weight: bold;');
            };

            console.log(
                "%c Theme Switcher Loaded! %c\nUse window.setTheme('light') or window.setTheme('dark') to switch themes.",
                'background: #ed145b; color: #fff; font-weight: bold; padding: 4px; border-radius: 4px;',
                'color: #ed145b; font-weight: bold;'
            );
            console.log(`Current theme: ${theme} (resolved: ${resolvedTheme})`);
        }
    }, [setTheme, theme, resolvedTheme]);

    return null;
}
